import React from 'react';
import Popup from 'reactjs-popup';
import '../../styles/popupBundler.scss';
import { assign as _assign, get as _get } from 'lodash-es';

const popupStyles = {
  borderRadius: '25px',
  boxShadow: '0 5px 30px rgba(0, 0, 0, 0.4)',
  border: '0px',
  padding: 0,
  maxWidth: '600px',
  width: '90%',
  height: 'fit-content',
};

const xrsclose = {
  width: '100px',
  cursor: 'pointer',
  position: 'absolute',
  display: 'block',
  lineHeight: '50px',
  fontSize: '27px',
  background: 'rgba(0, 0, 0, 0) none repeat scroll 0% 0%',
  right: '-18px',
  top: '5px',
  padding: '0px 20px',
  border: 'medium none',
  zIndex: 2,
};

const overlayStyle = {
  background: 'rgba(0, 0, 0, 0.4)',
};

const industryName = _get(
  window,
  'compatioConfig.compatibleProducts.industryName'
)
  ? _get(window, 'compatioConfig.compatibleProducts.industryName')
  : 'Fly Fishing';

const PopupXRS = () => {
  const description = (
    <span>
      Compatible product recommendations are powered by the Compatio Product
      Graph&#174;, a knowledge base maintained by {industryName} experts.
      <br />
      <br />
      The Product Graph&#174; enables you to more easily find the products that
      will work together to fit your needs. <br />
      <br /> Compatio is committed to accuracy and completeness. See something
      that doesn’t look right?{' '}
    </span>
  );
  return (
    <Popup
      trigger={
        <img
          src={
            'https://d1qrqn8mibon78.cloudfront.net/powered-by-compatio-question.png'
          }
          alt="?"
          width="20"
          height="20"
        />
      }
      position="center center"
      modal
      closeOnDocumentClick
      contentStyle={popupStyles}
      overlayStyle={overlayStyle}
    >
      {close => (
        <div className="xrs-popup">
          <button
            className="xrs-info-close"
            style={xrsclose}
            onClick={() => {
              close();
            }}
          >
            &times;
          </button>
          {description}
          <a
            href="https://www.compat.io/feedback"
            target="_blank"
            rel="noopener noreferrer"
          >
            <u>Let us know here.</u>
          </a>
          <br></br>
          <img
            className="xrs-popup-logo"
            src="https://d1qrqn8mibon78.cloudfront.net/powered-by-compatio.png"
            alt="Compatio"
          />
        </div>
      )}
    </Popup>
  );
};

export default PopupXRS;
